import { render, staticRenderFns } from "./MarkingExamCreateModal.vue?vue&type=template&id=20dc085c"
import script from "./MarkingExamCreateModal.vue?vue&type=script&lang=js"
export * from "./MarkingExamCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports